import angular from 'angular';
import moment from 'moment';

class companyCtrl {
  /* @ngInject */
  constructor(
    $scope,
    $filter,
    $translate,
    uiGridExporterConstants,
    AuthSvc,
    i18nService,
    CompanyService,
    DoSvc,
    PrincipalSvc,
    CompanyFilter,
    uiGridConstants
  ) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$translate = $translate;
    this.uiGridExporterConstants = uiGridExporterConstants;
    this.AuthSvc = AuthSvc;
    this.i18nService = i18nService;
    this.CompanyService = CompanyService;
    this.DoSvc = DoSvc;
    this.PrincipalSvc = PrincipalSvc;
    this.CompanyFilter = CompanyFilter;
    this.uiGridConstants = uiGridConstants;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());
    // Accès raccourcis aux autorisations depuis le scope principal
    this.isAuthorized = this.AuthSvc.isAuthorized;
    this.criteriaCP = new this.CompanyFilter();
    this.initCompaniesSearchFilter();

    this.PrincipalSvc.listPrincipals().then(data => {
      this.principals = data;
    });

    var defaultCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.detailscompanies({ id:row.entity.principalId, legalEntityId : row.entity.companyId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
    var translatedCountryCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.detailscompanies({ id:row.entity.principalId, legalEntityId : row.entity.companyId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{\'country.\' + COL_FIELD.toLowerCase() | translate}}</div></a>';
    var containerCellTemplate =
      '<div class="ui-grid-cell-contents ui-grid-cursor-pointer"><span style="color: blue; cursor: pointer;" ng-click="grid.appScope.$ctrl.goToContainer(row)"><u>{{COL_FIELD}}</u></span></div>';
    var fiscalCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.detailscompanies({ id:row.entity.principalId, legalEntityId : row.entity.companyId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{row.entity.fiscalId ? COL_FIELD : row.entity.legalId}}</div></a>';

    this.$scope.includes = {
      errorMessages: require('../../../app/layouts/error-messages.html')
    };

    this.companiesGridOptions = {
      columnDefs: [
        {
          name: 'DoEidWithId',
          displayName: 'principal.company.column.principal.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'principalName',
          displayName: 'principal.company.column.principal.name',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: this.uiGridConstants.ASC, priority: 0 },
          type: 'number'
        },
        {
          name: 'companyId',
          displayName: 'principal.company.column.company.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'companyName',
          displayName: 'principal.company.column.company.name',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: this.uiGridConstants.ASC, priority: 1 }
        },
        {
          name: 'fiscalId',
          displayName: 'principal.company.column.company.fiscal_national',
          cellTemplate: fiscalCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'companyCountry',
          displayName: 'principal.company.column.companyCountry',
          cellTemplate: translatedCountryCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'nbContainers',
          displayName: 'principal.company.column.nbContainers',
          cellTemplate: containerCellTemplate,
          headerCellFilter: 'translate',
          enableSorting: false
        }
      ],
      enableGridMenu: false,
      enableRowSelection: true,
      enableSelectAll: true,
      selectionRowHeaderWidth: 30,
      exporterMenuCsv: true,
      exporterMenuPdf: false,
      exporterCsvColumnSeparator: ';',
      exporterOlderExcelCompatibility: true,
      enableColumnMenus: false,
      exporterHeaderFilter: this.$translate.instant,
      gridMenuTitleFilter: this.$translate,
      exporterFieldCallback: (grid, row, col, value) => {
        if (col.name === 'companyCountry') {
          value = this.$translate.instant(value);
        }
        return value;
      },
      onRegisterApi: gridApi => {
        this.gridCompaniesApi = gridApi;
      }
    };

    (() => {
      var companyHistorySearchCriteria = this.PrincipalSvc.getCompanyListFilter();
      if (companyHistorySearchCriteria) {
        this.criteriaCP = companyHistorySearchCriteria;
      }
    })();

    // Check if all fields are empty to disable search on init.
      if(!Object.values(this.criteriaCP).every(criteria => criteria === null)){
          this.searchCompanies();
      }
  }

  clearSearchCompanies() {
    this.initCompaniesSearchFilter();
    this.criteriaCP.companyCountry = this.criteriaCP.selectedCountry ? this.criteriaCP.selectedCountry.code : null;
    this.$scope.$parent.principalIdSelected = null;
    this.PrincipalSvc.setCompanyListFilter(this.criteriaCP);
    this.companiesGridOptions.data = this.CompanyService.searchByCriterias(
      this.getPreparedCriteriaForserver(),
      data => {
        this.updateCompaniesCells(this.CompanyService, data);
      }
    );
  }

  searchCompanies() {
    this.PrincipalSvc.setCompanyListFilter(this.criteriaCP);
    this.criteriaCP.companyCountry = this.criteriaCP.selectedCountry ? this.criteriaCP.selectedCountry.code : null;
    this.companiesGridOptions.data = this.CompanyService.searchByCriterias(
      this.getPreparedCriteriaForserver(),
      data => {
        this.updateCompaniesCells(this.CompanyService, data);
      }
    );
    this.companyPromise = this.companiesGridOptions.data.$promise;
  }

  view(row) {
    var principal = this.PrincipalSvc.refreshPrincipal(row.entity.principalId, null, null);
    this.PrincipalSvc.setPrincipal(principal);
  }

  // Exporter le tableau
  exportCsv() {
    this.companiesGridOptions.exporterCsvFilename = 'societes_' + moment().format('DDMMYYYY') + '.csv';
    this.companiesGridOptions.exporterHeaderFilter = this.$translate.instant;
    this.gridCompaniesApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
  }

  updateCompaniesCells(CompanyService, data) {
    this.countContainerCriteria = [];
    angular.forEach(data, (value /*, key*/) => {
      this.countContainerCriteria.push(value.companyId);
    });
    this.countedContainer = this.CompanyService.countContainer(this.countContainerCriteria, (/*data*/) => {
      for (var i = 0; i < this.companiesGridOptions.data.length; i++) {
        for (var j = 0; j < this.countedContainer.length; j++) {
          if (this.countedContainer[j].companyId == this.companiesGridOptions.data[i].companyId) {
            this.companiesGridOptions.data[i].nbContainers = this.countedContainer[j].nbContainer;
            break;
          }
        }
      }
    });
  }

  initCompaniesSearchFilter() {
    this.criteriaCP = new this.CompanyFilter();
  }

  getNameIdentifier(val) {
    return this.CompanyService.autocompleteNameId({ data: val }).$promise.then(result => {
      return result;
    });
  }

  /**
   * Prepare le critère de recherche avant de les envoyer au serveur.
   */
  getPreparedCriteriaForserver() {
    var criteria = angular.copy(this.criteriaCP);
    delete criteria.selectedCountry;
    return criteria;
  }

  getTableHeight(gridApi) {
    var rowHeight = 30;
    var headerHeight = 30;
    var scrollHeight = 20;
    var footerHeight = 32;
    return {
      height:
        gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight + headerHeight + scrollHeight + footerHeight + 'px'
    };
  }

  goToContainer(row){
    this.DoSvc.goToContainer(row);
  }

}

angular.module('principal').component('company', {
  templateUrl: require('./company.html'),
  controller: companyCtrl,
  bindings: {}
});
